import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

/**
 * Einstiegspunkt der React-Anwendung
 * Rendert die Hauptkomponente in das DOM-Element mit der ID 'root'
 * 
 * Diese Datei wird von Vite als Entry Point verwendet und startet
 * die gesamte React-Anwendung
 */
ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
) 